import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { AppService } from '../../app.service';
import { StoreIdService } from '../services/store-id.service';

export const LoyaltyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storeIdService = inject(StoreIdService);
  const configService = inject(ConfigService);
  const appService = inject(AppService);

  const appStatus = toObservable(appService.appInitStatus);

  return appStatus.pipe(
    filter((status) => status === 'COMPLETE'),
    map(() => {
        const store = configService.configState().store!;
        if(!!store.hasLoyalty && !store.hasThirdPartyLoyalty){
          return true;
        } else {
          router.navigate([`/${storeIdService.getStorePathPrefix()}`]);
          return false;
        }
    }));
};
